import { Alert } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import useDeleteLocationJob from '../../../../useDeleteLocationJob';

function DeleteLocationAlert(): JSX.Element | null {
  const { t } = useTranslation('shipping', {
    keyPrefix: 'locations.delete.alert',
  });
  const { jobStatus, jobData, removeJob } = useDeleteLocationJob();

  const { operationType, sourceName, destinationName } = jobData ?? {};

  const title = t(`${operationType}.${jobStatus}.title`, {
    sourceName,
  });

  const description = t(`${operationType}.${jobStatus}.description`, {
    sourceName,
    destinationName,
  });

  const appearance = {
    pending: 'primary',
    ready: 'success',
    failed: 'warning',
  }[jobStatus];

  const handleDismiss = jobStatus !== 'pending' ? removeJob : undefined;
  const shouldShow = jobStatus && jobStatus !== 'idle';

  if (!shouldShow) return null;

  return (
    <Alert title={title} appearance={appearance} onRemove={handleDismiss}>
      {description}
    </Alert>
  );
}

export default DeleteLocationAlert;
